const themeOptions = {
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#ecb124',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      // light: will be calculated from palette.secondary.main,
      main: '#ecb124',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: will be calculated to contrast with palette.secondary.main
    },
    error: {
      // light: will be calculated from palette.error.main,
      main: '#ee0000',
      // dark: will be calculated from palette.error.main,
      // contrastText: will be calculated to contrast with palette.error.main
    },
  },
  typography: {
    fontFamily: ['"Roboto"', '"Open Sans"', '"Helvetica"', '"Arial"'].join(','),
  },
}

export default themeOptions
